import React from "react";
import { ReactComponent as LIVE_DEMO } from "../img/work-link_icons/live.svg";

export const LiveDemo = () => {
  return <LIVE_DEMO title="live demo" />;
};
